import Actions from '../../odata/actions';

const actions = new Actions('farm', 'farms');

export default actions;
